import {
  GetSectionPostOptionsProps,
  PostOption,
  SectionPostOptions,
} from '../../../helpers/types'

/* getExpandableStoryModule takes a post component's post options and converts them to a dynamic module Component */
export const getExpandableStoryModule = ({
  module,
}: GetSectionPostOptionsProps): SectionPostOptions => {
  let cta = module?.igExpandableStoryLinkAdCtaOption
  if (typeof cta === 'object')
    cta = (module?.igExpandableStoryLinkAdCtaOption as PostOption)?.selected
      ?.title
  if (!cta) cta = ''

  return {
    cta: cta,
    ctaUrl: module?.igExpandableStoryLinkAdWebsiteUrlOption || '',
  }
}
